<template>
    <ion-page>
        <ion-header>
            <ion-item class="mt-4" color="light" lines="none" v-if="show_search">
                <SearchBar class="no-search-padding" ref="search" autofocus position="start" mode="ios"
                    v-model="search" placeholder="Zoeken">
                </SearchBar>
            </ion-item>
        </ion-header>

        <ion-content color="light">
            <ion-refresher slot="fixed" pull-factor="0.5" pull-min="100" pull-max="200" @ionRefresh="refresh">
                <ion-refresher-content></ion-refresher-content>
            </ion-refresher>

            <Loading v-if="loading"></Loading>

            <no-data v-else-if="filteredItems.length == 0 && !hasDefaultItem" :icon="icon">
                <template #info>
                    <slot name="no-data"></slot>
                </template>
            </no-data>
            <template v-else>
                <ion-list :inset="inset" lines="inset" ref="list" class="mt-2">
                    <template v-if="!dont_show_recently_searched">
                        <span v-if="search.length == 0 && getLastSearchedItems.length > 0"
                            class="list-divider">Recentelijk
                            gezocht</span>


                        <ion-item v-if="search.length > 0 && hasDefaultItem" @click="addNew()" button :detail="false">
                            {{ search }}
                            <mdicon slot="end" name="plus-circle-outline" class="color-primary"></mdicon>
                        </ion-item>

                        <template v-if="search.length == 0">
                            <ion-item v-for=" item in getLastSearchedItems" :key="item.item.id" v-ripple :detail="false"
                                button @click="open(item.item)" class="ion-item-clickable">
                                <ion-thumbnail v-if="thumbnail" slot="start">
                                    <slot name="thumbnail" v-bind="item.item"></slot>
                                </ion-thumbnail>
                                <ion-label :class="truncate ? 'no-truncate' : null" class="clickable-label">
                                    {{ item.item.name }}<br />
                                    <created-at v-if="!no_created_at" :created_at="item.date"></created-at>
                                    <slot name="badges" v-bind="item.item"></slot>
                                </ion-label>
                                <slot name="chips" v-bind="item.item"></slot>
                                <mdicon slot="end" name="plus-circle-outline" class="color-primary"></mdicon>
                            </ion-item>
                        </template>
                        <span v-if="search.length == 0 && getLastSearchedItems.length > 0"
                            class="list-divider">Overig</span>
                    </template>

                    <ion-item v-for="item in filteredItems" :key="item[getKeyField]" v-ripple :detail="false" button
                        @click="open(item)" class="ion-item-clickable">
                        <ion-thumbnail v-if="thumbnail" slot="start">
                            <slot name="thumbnail" v-bind="item"></slot>
                        </ion-thumbnail>
                        <ion-label :class="truncate ? 'no-truncate' : null" class="clickable-label">
                            {{ item[getFieldName] }}<br />
                            <created-at v-if="!no_created_at" :created_at="item.created_at"></created-at>
                            <slot name="badges" v-bind="item"></slot>
                        </ion-label>
                        <slot name="chips" v-bind="item"></slot>

                        <mdicon slot="end" name="plus-circle-outline" class="color-primary"></mdicon>
                    </ion-item>
                </ion-list>
            </template>
        </ion-content>
    </ion-page>
</template>
<script>
import Fuse from "fuse.js";
import { add, filter } from "ionicons/icons";
import { cloudOffline } from "ionicons/icons";
import { VueScreenSizeMixin } from "vue-screen-size";

import { IonList, IonItem, IonThumbnail, IonLabel, IonRefresher, IonRefresherContent, IonSearchbar } from "@ionic/vue";
import NoData from "./NoData.vue";
import Loading from "./Loading.vue";

export default {
    name: "novacheck-list",
    props: [
        "trailing_new",
        "icon",
        "items",
        "field_name",
        "loading",
        "show_search",
        "can_delete",
        "size",
        "thumbnail",
        "done_loading",
        "item_size",
        "no_created_at",
        "truncate",
        "last_searched_section",
        "parent_uuid",
        "inset",
        "max_items",
        "no_padding",
        "dont_show_recently_searched",
    ],
    mixins: [VueScreenSizeMixin],
    components: {
        IonList,
        IonItem,
        IonThumbnail,
        IonLabel,
        IonRefresher,
        IonRefresherContent,
        IonSearchbar,
        NoData,
        Loading,
    },
    data() {
        return {
            cloudOffline,
            search: "",
            filter: filter,
            desc: false,
        };
    },
    emits: ["refresh", "open", "deleteItem"],
    methods: {
        addNew() {
            // we find the default item and open it
            let default_item = this.items.find((item) => item.code == "DEFCO");

            if (default_item) {
                default_item[this.getFieldName] = this.search;
                this.open(default_item);
            }
        },
        toggleFavorite(item) {
            let all_items = this.$store.getters.getLastSearchedItems;
            let filtered_items = all_items.filter((i) => i.item.id != item.item.id);
            filtered_items.push({ item: item.item, section: item.section, date: new Date(), favorite: !item.favorite });

            this.$store.dispatch("setLastSearchedItems", filtered_items);
        },
        open(item) {
            this.$emit("open", item);

            if (this.last_searched_section) {
                var all_items = this.getLastSearchedItems;
                var filtered_items = all_items.filter((i) => i.item.id != item.id);
                var item_to_add = {
                    item: item,
                    section: this.last_searched_section,
                    date: new Date(),
                    favorite: false,
                };

                filtered_items.push(item_to_add);

                // max 5 items. Remove the oldest one if its not a favorite
                if (filtered_items.length > 6) {
                    // find the non favorites
                    let non_favorites = filtered_items.filter((i) => !i.favorite);

                    // remove the oldest
                    let oldest = non_favorites.reduce((oldest, current) => {
                        return oldest.date < current.date ? oldest : current;
                    }, non_favorites[0]);

                    filtered_items = filtered_items.filter((i) => i.item.id != oldest.item.id);
                }
            }

            this.$store.dispatch("setLastSearchedItems", filtered_items);
        },
        setDesc() {
            this.desc = !this.desc;
        },
        getFirstLetter(name) {
            return name.charAt(0);
        },
        refresh($event) {
            this.$emit("refresh", $event);
            $event.target.complete();
        },
        deleteComponent(item) {
            this.$refs.list.$el.closeSlidingItems();
            this.$emit("deleteItem", item);
        },
        deleteLastSearchedItem(item) {
            let all_items = this.$store.getters.getLastSearchedItems;
            let filtered_items = all_items.filter((i) => i.item.id != item.id);
            this.$store.dispatch("setLastSearchedItems", filtered_items);
        },
    },
    computed: {
        hasDefaultItem() {
            // we search in items array if we have code field and if one of the items has a code field with DEFCO, we return true
            return this.items.some((item) => item.code == "DEFCO");
        },
        getKeyField() {
            if (!this.items || this.items.length == 0) {
                return "uuid";
            } else if (this.items[0].uuid) {
                return "uuid";
            }

            return "id";
        },
        getFieldName() {
            if (this.field_name) {
                return this.field_name;
            } else {
                return "name";
            }
        },
        filteredItems() {
            let items = this.items

            if (this.search == "") {
                if (this.max_items) {
                    return items.slice(0, this.max_items);
                }
                return items;
            }

            const options = {
                keys: ["name", "remark"],
                threshold: 0.3,
                shouldSort: true,
            };

            const fuse = new Fuse(items, options);

            let search_result = fuse.search(this.search);
            search_result = search_result.map((item) => item.item);

            if (this.max_items) {
                return search_result.slice(0, this.max_items);
            }

            return search_result;
        },
        getLastSearchedItems() {
            let all_items = this.$store.getters.getLastSearchedItems;
            if (all_items) {
                // Filter items based on whether parent_uuid is present and the item's parent status
                let filtered_items = all_items.filter((item) => {
                    // If parent_uuid is not present, filter for items where item.parent is true
                    // If parent_uuid is present, filter for items where item.parent is false
                    return this.parent_uuid
                        ? item.section == this.last_searched_section && !item.item.parent
                        : item.section == this.last_searched_section && item.item.parent;
                });

                // Sorting by date - assuming you want the most recent first
                // Notice that we're using `>` operator to compare dates
                filtered_items.sort((a, b) => {
                    return b.date - a.date;
                });

                // Sorting by favorites - favorites come first
                // This sort is stable, so it will keep the order from the previous sort
                filtered_items.sort((a, b) => {
                    return b.favorite === a.favorite ? 0 : b.favorite ? 1 : -1;
                });

                return filtered_items;
            }

            return [];
        },
    },
};
</script>
<style scoped>
.scroller {
    height: 100%;
}

.ion-item-clickable {
    cursor: pointer;
}

/* Ensure ion-label does not interfere with the click events */
.clickable-label {
    pointer-events: none;
}

/* Ensure no pointer-events for child elements to allow full item click */
.ion-item-clickable ion-thumbnail,
.ion-item-clickable slot {
    pointer-events: none;
}

.list-divider {
    font-size: 13px;
    color: var(--ion-color-medium);
    display: block;
    padding-left: 15px;
    padding-top: 20px;
    padding-bottom: 5px;
}
</style>
